import React from 'react';
import styled from 'styled-components';

const SecondaryHeading = ( { text }: any ) => {

    return (

        <SecondaryHeadingWrapper>
            <h2>{ text }</h2>            
        </SecondaryHeadingWrapper>
    )
}


export default SecondaryHeading;


const SecondaryHeadingWrapper = styled.div`

    padding: 10px;
    font-size: 24px;
    color: #5f4a03;
    letter-spacing: 2px;
    text-transform: uppercase;
    text-align: center;

`;